import { useResetRecoilState } from "recoil";
import {
  authUserState,
  isLoggedInState,
  pageState,
  sidenavIsPinnedState,
} from "../storage/app";

export function useClearStorage() {
  const atomsToReset = [
    useResetRecoilState(isLoggedInState),
    useResetRecoilState(sidenavIsPinnedState),
    useResetRecoilState(pageState),
    useResetRecoilState(authUserState),
  ];

  const clearStorage = () => {
    atomsToReset.forEach((resetAtom) => resetAtom());
    localStorage.clear();
  };

  return clearStorage;
}
